(function(window, angular){'use strict';

var ngModule = angular.module('pp.widgets.financials-property-units', ['pp.widgets-templates']);

ngModule.component('ppFinancialsPropertyUnits', {
    templateUrl: 'widgets/_angular/financials-property-units/financials-property-units.tpl.html',
    bindings: {
        property: '<',
        unitsDisclosure: '<',
        unitValuationDate: '<'
    },
    controllerAs: 'vm',
    controller: ['$scope', function ($scope) {
        var vm = this;

        // -- initial state

        // -- util functions

        // -- api

        // -- scope bindings

        // -- main

    }]
});
})(window, window.angular);